
export class UserPreferences {
    constructor({
        id=null,
        language= `en`,
        timezone= `D`,
        dateFormat= `D`,
        user={}
     } = {}) {
        this.id = id;
        this.language = language;
        this.timezone = timezone;
        this.dateFormat = dateFormat;
        this.user = user
    }
  }

  export function newEntity() {
    return new UserPreferences();
  }

  export const fields = Object.freeze(Object.keys(new UserPreferences()).map(i => i.toString()));